// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"b691744b","119":"68b05a90","227":"22ebee70","239":"b2cd08c3","358":"e13bfd62","423":"7f5bd5e8","667":"000ec0f6","963":"e2353336"}[chunkId] + ".chunk.js";
};